export default class Formio {
  constructor(dto = {}) {
    Object.assign(this, dto);
  }
}
